"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function (o, m, k, k2) {
    if (k2 === undefined)
        k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
        desc = { enumerable: true, get: function () { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function (o, m, k, k2) {
    if (k2 === undefined)
        k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function (o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function (o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function (o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o)
                if (Object.prototype.hasOwnProperty.call(o, k))
                    ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule)
            return mod;
        var result = {};
        if (mod != null)
            for (var k = ownKeys(mod), i = 0; i < k.length; i++)
                if (k[i] !== "default")
                    __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.AttributeValueList = void 0;
const react_1 = __importStar(require("react"));
const ramda_1 = require("ramda");
const attribute_value_item_1 = require("./attribute-value-item");
const strategy_attribute_item_styles_1 = require("./strategy-attribute-item/strategy-attribute-item.styles");
const hooks_1 = require("../../../hooks");
const generic_1 = require("../../../generic");
const hooks_2 = require("../../../hooks");
const store_1 = require("../../../../store");
const AttributeValueList = ({ values, attributeName, isDisabled, showOnlySelectedValue, isAttributeSelected, isAttributeModified, selectedAttributeValue, selectedMeasureUnit, columnCount, itemWidth, itemMaxWidth, isCheckDisabled, hasNextPage, moreItemsLoading, onLoadMore, checkIsValueChecked, onSelect, onCheck, onStrategize, }) => {
    const lastElementRef = (0, hooks_1.useLoadMore)({
        moreItemsLoading,
        hasNextPage,
        onLoadMore,
    });
    const { checkIsValueChanged } = (0, hooks_2.useIsEntityChanged)();
    const filterState = (0, store_1.useAttributesFilter)();
    const attributeValues = (0, react_1.useMemo)(() => {
        // showOnlySelectedValue — existing logic for selected-node view
        let result = values;
        if (showOnlySelectedValue && !isDisabled) {
            const selectedItem = values.find(({ value, isMeasureUnit }) => value === (isMeasureUnit ? selectedMeasureUnit : selectedAttributeValue));
            result = selectedItem ? [selectedItem] : [];
        }
        // Apply filter from Redux (only when filter is active)
        const { selectedAttributes, selectedValues, deselectedValues } = filterState;
        if (selectedAttributes !== null) {
            const includeKeys = selectedValues
                .filter((k) => k.startsWith(`${attributeName}::`))
                .map((k) => k.slice(attributeName.length + 2));
            const excludeKeys = deselectedValues
                .filter((k) => k.startsWith(`${attributeName}::`))
                .map((k) => k.slice(attributeName.length + 2));
            if (includeKeys.length > 0) {
                result = result.filter((v) => includeKeys.includes(v.value));
            }
            else if (excludeKeys.length > 0) {
                result = result.filter((v) => !excludeKeys.includes(v.value));
            }
        }
        return result;
    }, [showOnlySelectedValue, isDisabled, values, selectedMeasureUnit, selectedAttributeValue, filterState, attributeName]);
    const hasMeasures = (0, react_1.useMemo)(() => attributeValues.some(({ isMeasureUnit }) => isMeasureUnit), [attributeValues]);
    const rowCount = (0, react_1.useMemo)(() => {
        const newColumnCount = hasMeasures ? 1 : columnCount;
        return Math.ceil(attributeValues.length / newColumnCount);
    }, [attributeValues, columnCount, hasMeasures]);
    const handleSelectValue = (0, react_1.useCallback)((value, isMeasureUnit) => onSelect(Object.assign({ label: attributeName }, isMeasureUnit ? { unit: value } : { value })), [attributeName, onSelect]);
    const handleSelectNestedValue = (0, react_1.useCallback)((value, unit) => onSelect(Object.assign({ label: attributeName }, unit ? { unit, value } : { value })), [attributeName, onSelect]);
    const handleCheckValue = (0, react_1.useCallback)((value, isChecked) => onCheck({ label: attributeName, value }, isChecked), [attributeName, onCheck]);
    const lastItemIndex = values.length - 1;
    return (react_1.default.createElement(strategy_attribute_item_styles_1.StyledValuesScrollContainer, null, react_1.default.createElement(strategy_attribute_item_styles_1.StyledAccordionDetails, { "$hasMeasures": hasMeasures, "$rowCount": rowCount, "$itemWidth": itemWidth, "$itemMaxWidth": itemMaxWidth }, attributeValues.map((attributeValue, index) => {
        var _a;
        const { value, productCount, isValid, isMeasureUnit, nestedValues, isModified, } = attributeValue;
        const isChecked = (_a = (!isCheckDisabled && (checkIsValueChecked === null || checkIsValueChecked === void 0 ? void 0 : checkIsValueChecked(value)))) !== null && _a !== void 0 ? _a : false;
        const isChanged = checkIsValueChanged(attributeName, value);
        const selectedEntityValue = (isMeasureUnit && !selectedAttributeValue) ? selectedMeasureUnit : selectedAttributeValue;
        const handleStrategize = () => onStrategize === null || onStrategize === void 0 ? void 0 : onStrategize(value);
        return (react_1.default.createElement(attribute_value_item_1.AttributeValueItem, { key: value, ref: index === lastItemIndex ? lastElementRef : undefined, value: value, isMeasureUnit: isMeasureUnit, isChecked: isChecked, isStrategized: isValid, showStrategizedIndicator: !(0, ramda_1.isNil)(isValid) && !isAttributeModified, isSelectDisabled: isDisabled, isCheckDisabled: isCheckDisabled || isMeasureUnit, isSelected: isAttributeSelected && value === selectedEntityValue, productCount: productCount, isChanged: isChanged || isModified, isModified: isModified, onSelect: handleSelectValue, onCheck: handleCheckValue, onStrategize: handleStrategize }, nestedValues === null || nestedValues === void 0 ? void 0 : nestedValues.map(({ value: nestedValue, productCount }) => (react_1.default.createElement(attribute_value_item_1.AttributeValueItem, { key: nestedValue, isCheckHidden: true, value: nestedValue, productCount: productCount, isSelected: nestedValue === selectedAttributeValue, onSelect: (selectedNestedValue) => handleSelectNestedValue(selectedNestedValue, isMeasureUnit ? value : null) })))));
    })), moreItemsLoading && react_1.default.createElement(generic_1.LoadingIndicator, { className: "load-more-indicator" })));
};
exports.AttributeValueList = AttributeValueList;
exports.default = exports.AttributeValueList;
